import React from 'react';
import Link from 'next/link';
import SectionTitle from '../../components/SectionTitle';

import styles from './style.module.css';

const AYCESection = ({menuUrl}) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.title}>
        <SectionTitle
          title='Menu'
          subtitle='ALL YOU CAN EAT NOW AVAILABLE!'/>
      </div>
      <div className={styles.button_wrapper}>
        <Link href={menuUrl} legacyBehavior>
          <button className='custom__button'>View Full Menu</button>
        </Link>
      </div>
      <div className={styles.video_wrapper}>
        <video
          className={styles.video}
          controls={true}>
          <source
            src={`https://cdn.shakingcrab.com/AYCE.mp4`} />
        </video>
      </div>
    </div>
  );
};

export default AYCESection;
